<template>
  <div class="flex flex-col items-center justify-center disclaimer-dark">
    <v-photo-swipe fade-transition class="flex items-center justify-center w-full h-full gallery">
      <swiper
        :slides-per-view="5"
        :space-between="0"
        free-mode
        watch-slides-visibility
        class="flex-1 w-full h-full"
        :class="{ 'swiper-center': gallery.images.length < 6 }"
        @swiper="onSwiper"
      >
        <swiper-slide v-for="image in gallery.images" :key="image.name" class="flex items-center justify-center">
          <a :href="`gallery/${gallery.id}/${image.name}`" :data-width="image.width" :data-height="image.height" class="block gallery-item">
            <img
              :src="`gallery/${gallery.id}/previews/${image.name}`"
              class="object-cover w-32 h-64 rounded-sm shadow-2xl xl:w-48 xl:h-96 2xl:w-64 2xl:h-128"
            >
          </a>
        </swiper-slide>
      </swiper>
    </v-photo-swipe>

    <div>
      <app-page-menu>
        <router-link
          v-for="link in collections"
          :key="link.id"
          :to="{ name: 'GalleryId', params: { id: link.id } }"
          active-class="text-escent"
        >
          {{ link.name }}
        </router-link>
      </app-page-menu>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
import SwiperCore, { Pagination, Scrollbar } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

import AppPageMenu from '@/components/AppPageMenu.vue'

SwiperCore.use([
  Pagination,
  Scrollbar,
])

export default {
  name: 'Gallery',
  components: {
    Swiper,
    SwiperSlide,
    AppPageMenu,
  },
  props: {
    id: {
      type: String,
      required: false,
      default: 'exterior',
    },
  },
  data () {
    return {
      collections: [
        {
          id: 'exterior',
          name: 'Exterior',
          images: [
            { name: 'SCENE_01_OVERALL_FINAL.jpg', width: 3840, height: 1920 },
            { name: 'SCENE_02_ENTRANCE_FINAL.jpg', width: 3840, height: 2024 },
            { name: 'SCENE_03_ROOFTOP_BUILDING_FINAL.jpg', width: 3840, height: 2135 },
            { name: 'SCENE_03_ROOFTOP_BUILDING_VIEW2_FINAL.jpg', width: 3840, height: 1920 },
          ],
        },
        {
          id: 'facilities',
          name: 'Facilities',
          images: [
            { name: 'CPN_ESCENT_KORAT_01LOBBY.jpg', width: 2200, height: 1540 },
            { name: 'CPN_ESCENT_KORAT_02LOBBY.jpg', width: 2200, height: 1540 },
            { name: 'CPN_ESCENT_KORAT_03SEMIOUTDOOR.jpg', width: 2200, height: 1540 },
            { name: 'CPN_ESCENT_KORAT_04SEMIOUTDOOR.jpg', width: 2200, height: 1540 },
            { name: 'CPN_ESCENT_KORAT_05GARDEN_LOUNGE.jpg', width: 2200, height: 1436 },
            { name: 'CPN_ESCENT_KORAT_06GARDEN_LOUNGE.jpg', width: 1716, height: 1540 },
            { name: 'CPN_ESCENT_KORAT_07GARDEN_LOUNGE.jpg', width: 1488, height: 1400 },
            { name: 'CPN_ESCENT_KORAT_08LIFT_HALL.jpg', width: 1488, height: 1808 },
            { name: 'CPN_ESCENT_KORAT_09LIFT_HALL.jpg', width: 1740, height: 1738 },
            { name: 'CPN_ESCENT_KORAT_10MAIL_BOX.jpg', width: 2000, height: 2000 },
            { name: 'CPN_ESCENT_KORAT_11LAUNDRY_CAFE.jpg', width: 1936, height: 1648 },
            { name: 'CPN_ESCENT_KORAT_12FITNESS.jpg', width: 1904, height: 1396 },
            { name: 'CPN_ESCENT_KORAT_13FITNESS.jpg', width: 1806, height: 1101 },
            { name: 'CPN_ESCENT_KORAT_14FITNESS.jpg', width: 1780, height: 1448 },
            { name: 'CPN_ESCENT_KORAT_15FITNESS.jpg', width: 1940, height: 1396 },
            { name: 'CPN_ESCENT_KORAT_15MEN_TOILET.jpg', width: 1576, height: 1500 },
            { name: 'CPN_ESCENT_KORAT_16MEN_TOILET.jpg', width: 1684, height: 1500 },
            { name: 'CPN_ESCENT_KORAT_17MEN_TOILET.jpg', width: 1298, height: 2010 },
            { name: 'CPN_ESCENT_KORAT_18WOMEN_TOILET.jpg', width: 1608, height: 1500 },
            { name: 'CPN_ESCENT_KORAT_19WOMEN_TOILET.jpg', width: 1688, height: 1500 },
            { name: 'CPN_ESCENT_KORAT_20WOMEN_TOILET.jpg', width: 1360, height: 1948 },
          ],
        },
        {
          id: 'interior',
          name: 'Interior',
          images: [
            { name: '28.jpg', width: 3840, height: 2304 },
            { name: '32.jpg', width: 3840, height: 1857 },
            { name: '35.jpg', width: 3840, height: 2285 },
            { name: '40.jpg', width: 3840, height: 1747 },
            { name: '52.jpg', width: 3840, height: 1839 },
            { name: '64.jpg', width: 3840, height: 1532 },
            { name: '95.jpg', width: 3840, height: 1221 },
          ],
        },
      ],

      swiper: undefined,
    }
  },
  computed: {
    gallery () {
      return this.collections.find(gallery => gallery.id === this.id)
    },
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'GalleryId') {
        this.$nextTick(() => {
          anime({
            targets: '.gallery-item > img',
            duration: 2000,
            opacity: [0, 1],
            translateY: [-200, 0],
            delay: anime.stagger(200),
          })
        })

        if (this.swiper) {
          this.swiper.slideTo(0)
        }
      }
    },

  },
  activated () {
    if (this.$route.name === 'GalleryId') {
      anime({
        targets: '.gallery-item > img',
        duration: 2000,
        opacity: [0, 1],
        translateY: [-200, 0],
        delay: anime.stagger(200),
      })
    }
  },
  methods: {
    onSwiper (swiper) {
      this.swiper = swiper
    },
  },
}
</script>

<style lang="postcss" scoped>
::v-deep(.swiper-container) {
  @apply px-16;

  @screen xl {
    @apply px-24;
  }

  @screen 2xl {
    @apply px-32;
  }

  &.swiper-center {
    .swiper-wrapper {
      @apply justify-center;
    }
  }

  .swiper-slide:nth-child(odd) {
    & > * {
      @apply transform translate-y-16;
    }
  }

  .swiper-slide:nth-child(even) {
    & > * {
      @apply transform -translate-y-16;
    }
  }
}
</style>
